import type { Country } from "../../types/country";
import type { AnyQuestion } from "../../types/question";
import { excludeLocalCountry } from "../../utils/country";
import CountriesMultiSelect from "./question-types/countries-multi-select";
import CountryAndTin from "./question-types/country-and-tin";
import MultipleChoiceQuestion from "./question-types/multiple-choice";
import { PepRelation } from "./question-types/pep-relation";
import SingleChoiceQuestion from "./question-types/single-choice";
import TextQuestion from "./question-types/text";

// import { assertUnreachable } from '../../types/utility';

type Props = {
	question: AnyQuestion;
	allCountries: Array<Country>;
};

const QuestionResolver = ({ question, allCountries }: Props) => {
	const countries = excludeLocalCountry(allCountries);
	const nonEesCountries = countries.filter((c) => !c.partOfEes);
	const internationalPaymentCountries = countries.filter((c) => c.internationalPayment);

	switch (question.questionType) {
		case "Text":
			return <TextQuestion question={question} />;
		case "SingleChoice":
			return <SingleChoiceQuestion question={question} />;
		case "MultipleChoice":
			return <MultipleChoiceQuestion question={question} />;
		case "AllCountriesMultipleChoice":
			return <CountriesMultiSelect countries={countries} question={question} />;
		case "InternationalPaymentsCountriesMultipleChoice":
			return <CountriesMultiSelect countries={internationalPaymentCountries} question={question} />;
		case "NonEesCountriesMultipleChoice":
			return <CountriesMultiSelect countries={nonEesCountries} question={question} />;
		case "CountryAndTinMultipleChoice":
			return <CountryAndTin question={question} countries={countries} isMultiSelect />;
		case "CountryAndTinSingleChoice":
			return <CountryAndTin question={question} countries={countries} />;
		case "PepRelationQuestion":
			return <PepRelation question={question} />;
		default:
			// return assertUnreachable(question);
			return null; // todo: remove later when we can assert that every type is handled
	}
};

export default QuestionResolver;
